import layout from '@/views/layout/layout.vue'
const newsList = r => require.ensure([], () => r(require('@/views/wechatExcellent/news/list.vue')), 'group-wechatExcellent-news')

const wechatExcellentNews = [
  {
    path: '/wechatExcellent/news',
    name: 'wechatExcellent-news',
    component: layout,
    redirect: '/wechatExcellent/news/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: newsList,
        name: 'wechatExcellent-news-list',
        meta: {
          displayName: '商城内容管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default wechatExcellentNews



// WEBPACK FOOTER //
// ./src/router/wechatExcellent/news.js